import { render, staticRenderFns } from "./VacancyMap.vue?vue&type=template&id=2b074cec&"
import script from "./VacancyMap.vue?vue&type=script&lang=js&"
export * from "./VacancyMap.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports